<template>
<div class="kt-portlet kt-portlet--bordered my-3 border">
  <div
    class="kt-portlet__head px-3"
    :class="{ 'kt-bg-info': !isSelected, 'kt-bg-danger': isSelected }">
    <div class="kt-portlet__head-label">
      <h3 class="kt-portlet__head-title">
        <font-awesome-icon :icon="['fas', 'arrows-alt']" size="lg" class="iconDragAndDrop" />
        <span class="ml-2">{{ data.startdate | custom-date }}</span>
      </h3>
    </div>
    <div class="font-weight-normal">{{ data.locations | custom-join('name') }}</div>
  </div>
  <div class="kt-portlet__body py-2 px-3 collapsed">
    <div class="d-flex justify-content-between fw-600 py-0">
      <span :class="{ 'text-info': !isSelected, 'text-danger': isSelected }">
        <span
          class="kt-badge"
          :class="{ 'kt-badge--info': !isSelected, 'kt-badge--danger': isSelected }">
          {{ data.startday }}</span>
        <span class="ml-2">{{ data.title }}</span>
      </span>
      <span
        class="fw-600 mb-1"
        :class="{ 'text-info': !isSelected, 'text-danger': isSelected }"></span>
    </div>
    <div class="my-2" v-if="false"></div>
  </div>
</div>
</template>

<script>
export default {
  name: 'TabItineraryReorderItem',
  props: {
    data: {
      type: Object,
      required: true
    },
    selected: {
      type: Object,
      required: true
    }
  },
  computed: {
    isSelected () {
      if (this.selected && this.data) {
        return this.selected.data.id === this.data.id
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
  .kt-portlet {
    cursor: pointer;
    transition: background-color ease-in .2s;
    margin-bottom: 5px !important;
    box-shadow: 0 0 3px #ccc;
  }
  .kt-portlet:hover {
    background-color: #ffffff;
  }
  .kt-portlet__head {
    min-height: 30px;
    align-items: center;
    background-color: #999999;
    color: white !important;
    border-bottom: 0;
    padding: 5px 10px!important;
  }
  .kt-portlet__head.isDropped {
    background-color: #5cb85cff;
  }
  .kt-portlet__head-title {
    font-size: 1rem !important;
    color: white !important;
  }
  .kt-portlet__body {
    color: #555;
    padding: 10px 10px!important;
  }
  .kt-portlet.collapsed .kt-portlet__body {
    height: 0;
    overflow: hidden;
    padding: 0 !important;
    transition: all 0.3s ease-out;
  }
  .ResultBox-toggleDescription {
    font-size: .86rem;
    font-weight: 500;
    text-decoration: underline;
  }
  .kt-portlet__head-title .ml-2{
    position: relative;
    top: -1px;
  }
</style>
